import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Home from "../pages/Home";
import CustomRouter from "./CustomRouter";
import ProtectedRoute from "./ProtectedRoute";
import LoadingPage from '../components/loader/LoadingPage';

const RootRouter = () => {
  return (
    <CustomRouter>
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route
          path='/dashboard'
          element={<ProtectedRoute Component={Dashboard} />}
        />
        <Route exact path="/auth/callback" element={<LoadingPage />} />
      </Routes>
    </CustomRouter>
  );
};
export default RootRouter;
